import {
  FAILURE,
  PENDING
} from '../../utils/status';


export function poi(state, poi_uid) {
  let poi = state.poi.detailNew.data.poi;

  if (poi && poi.poi_uid === poi_uid) {
    return poi;
  } else {
    return;
  }
}





export function nextStations(state) {
  return state.poi.detailNew.data.next_station || {};
}

export function videos(state) {
  return state.poi.detailNew.data.videos || {};
}

// init status
export function initStatus(state, poi) {
  let status = state.poi.detailNew.status;

  // 因为localState可能会保存上次成功请求
  if (status === FAILURE) {
    return status;
  } else if (!poi) {
    return PENDING;
  } else {
    return status;
  }
}




// WEBPACK FOOTER //
// ./src/components/Poi2/selector.js